export interface MessageProcessor {
  type: string
  handler: (data: any) => void
}

export enum WebSocketEndpoint {
  ADVISOR = '/advisor-chat/',
  NEGOTIATION = 'negotiation/',
  STUDENT_DECISION = 'decisions/',
  WAITING_ROOM = 'waiting_room/',
  ADJUDICATION = '/adjudication/',
  TIMER = 'timer/',
  TEST_CHAT = 'test-chat/',
  AI_PLAYER_TEST_CHAT = 'ai-player-test-chat/',
  GAME_ANALYSIS = 'game-analysis/',
  TEAM_CHAT = 'team_chat/',
  AI_PLAYER_CHAT = 'ai-player-chat/',
  NOTIFICATION = '/notifications/',
  CHARTER_PREP = 'charter/prep/',
  CHARTER_GROUP = 'charter/group/',
}
